var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"bordered":"","data-source":_vm.showList,"pagination":false}},[_c('a-table-column',{attrs:{"title":"资料类型","data-index":"typeValue"}}),_c('a-table-column',{key:"file",attrs:{"title":"文件名称"},scopedSlots:_vm._u([{key:"default",fn:function(text){return [_c('Download',{attrs:{"path":text.filePath}})]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }